var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat tw-flex"},[_c('div',{staticClass:"chat_main"},[_c('chat-window',{attrs:{"seller":_vm.seller}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }